import { Link } from "@certn/cascadia-react";
import { Trans } from "react-i18next";

interface SummaryEditLinkProps {
  href: string;
  testID: string;
}

export function SummaryEditLink({ href, testID }: SummaryEditLinkProps) {
  return (
    <Link
      href={href}
      linkStyle="monochrome"
      textColor="text-weak"
      testID={testID}
    >
      <Trans>Edit</Trans>
    </Link>
  );
}
